import React from 'react';
import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Kiosks',
		url: '/kiosks',
		icon: 'desktop',
	}
];

export default class Kiosk extends Framework.Components.View {
	render() {
		const breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/kiosks/${this.props.match.params.id}`,
				icon: 'edit',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Objects.Kiosk
						id={this.props.match.params.id}
						history={this.props.history}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={this.props.baseUrl}
					/>
				</Framework.Errors.General>
			</div>
		);
	}
}
